<section class="popular-links-mobile">
  <div
    [ngStyle]="{
      'height.px': showAllLinksButton ? (showAllLinks ? maxHeightMobile : minHeightMobile) : ''
    }"
    class="popular-links-mobile__container"
  >
    <div class="popular-links-mobile__grid">
      <ng-container *ngFor="let card of cardList | slice: 0:limit">
        <app-popular-links-card [card]="card" @fadeIn appDisableClickEvent></app-popular-links-card>
      </ng-container>
    </div>
  </div>
  <div *ngIf="showAllLinksButton" class="popular-links-mobile__show-all">
    <div class="popular-links-mobile__show-all__interaction-area" (click)="onShowAllClick()">
      {{ (showAllLinks ? 'SHARED.SHOW_LESS.LABEL' : 'CATALOG.CATALOG_PAGE.HUB.SHOW_ALL') | translate }}
      <mm-icon *ngIf="!showAllLinks" name="chevron-down"></mm-icon>
      <mm-icon *ngIf="showAllLinks" name="chevron-up"></mm-icon>
    </div>
  </div>
</section>
